export default __webpack_public_path__ + "static/media/bse.3b3f8d63.png";